/**
 * Tiny GA4 helper. Safe to call from anywhere — if window.gtag is not loaded
 * (because REACT_APP_GA_MEASUREMENT_ID is blank), all calls become no-ops.
 *
 * Usage:
 *   import { trackEvent } from './analytics';
 *   trackEvent('generate_lead', { event_label: 'header_call_now' });
 */
export const trackEvent = (eventName, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch (e) {
    // Never let analytics break the app
    // eslint-disable-next-line no-console
    console.debug('trackEvent failed', e);
  }
};
